import React from 'react';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, ShadowTypeTokens, SizeTypeTokens, } from '@voltmoney/schema';
import { FlatList, Pressable, View, } from 'react-native';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import Icon from '../icon/Icon';
import ThemeProvider from '@voltmoney/theme';
const BottomTab = ({ data, shadow = ShadowTypeTokens.E1, triggerAction, action, }) => {
    const theme = ThemeProvider.getTheme();
    const handleAction = (index) => {
        action &&
            triggerAction &&
            triggerAction({
                ...action,
                payload: { ...action.payload, value: index },
            });
    };
    return (React.createElement(View, { style: {
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            backgroundColor: ColorTokens.Grey_Milk,
            shadowColor: ColorTokens.Grey_Milk,
            shadowOpacity: 0.2,
            shadowOffset: {
                height: 1,
                width: 1,
            },
            paddingVertical: theme.paddingSize[SizeTypeTokens.MD],
            //paddingHorizontal:  SizeTypeTokens.XL,
            paddingHorizontal: 0,
            flexDirection: 'row',
        } },
        React.createElement(FlatList, { data: data, numColumns: 4, style: {
                //	paddingVertical: 10,
                width: '100%',
            }, ItemSeparatorComponent: () => (React.createElement(Space, { size: SizeTypeTokens.LG })), renderItem: ({ item, index }) => (React.createElement(View, { style: {
                    flex: 1,
                } },
                React.createElement(Pressable, { nativeID: item.qaId, onPress: () => handleAction(index) },
                    React.createElement(View, { style: {
                            flexDirection: 'column',
                            alignItems: 'center',
                        } },
                        React.createElement(Icon, { ...item['icon'] }),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        item['status'] == 'SELECTED' ? (React.createElement(Typography, { label: item['title'], fontFamily: FontFamilyTokens.Inter, lineHeight: 16, fontWeight: '600', fontSize: FontSizeTokens.XXS, color: ColorTokens.Primary_100 })) : (React.createElement(Typography, { label: item['title'], fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XXS, color: ColorTokens.Grey_Charcoal })))))), keyExtractor: (item, index) => index.toString() })));
};
export default React.memo(BottomTab);
export { BottomTab };
